export interface FeatureFlag {
	id: number;
	name: string;
	on: boolean;
	// New parameters must be optional or nullable
}

export enum FeatureFlagsEnum {
	firesides_broadcasting = 'streams.firesides_broadcasting',
	iOS_mobile_native_player = 'streams.iOS_mobile_native_player',
	emails_and_audiences = 'streams.emails_and_audiences',
	translations_v2 = 'streams.translations_v2',
	custom_templates = 'streams.custom_templates',
	greenroom_producer_url = 'streams.greenroom_producer_url',
	publishable_preview = 'streams.publishable_preview',
	quizzes = 'streams.quizzes',
	custom_mapping = 'streams.custom_mapping',
	magic_links = 'streams.magic_links',
	accordion_module = 'streams.accordion_module',
	admin_email_verification = 'streams.admin_email_verification',
	event_hierarchy = 'streams.event_hierarchy',
	jackson_sso = 'streams.jackson_sso',
	leaderboard = 'streams.leaderboard',
	event_templates = 'streams.event-templates',
	gdpr_marketing_email_double_optin = 'streams.gdpr_marketing_email_double_optin',
	event_cookie_settings = 'streams.event_cookie_settings',
	content_speakers = 'streams.content_manager_speaker',
	navbar_v2 = 'streams.navbar_v2',
	session_details_v2 = 'streams.session_details_v2',
	api_keys = 'streams.api_keys',
	translations_v3 = 'streams.translations_v3',
	video_v2 = 'streams.video_v2',
	google_meet_phase_1 = 'streams.meet_powered_breakouts_phase_1',
	integrations_ui_q3_2023 = 'streams.integrations_ui_q3_2023',
	audience_list_ui_q3_2023 = 'streams.audience_list_ui_q3_2023',
	announcements_v2_q4_2023 = 'streams.announcements_v2_q4_2023',
	metrics_api = 'streams.metrics_api',
	registration_v2_q1_2024 = 'streams.registration_v2_q1_2024',
	go_to_greenroom_for_all_broadcast_types = 'streams.go_to_greenroom_for_all_broadcast_types',
	admin_privileges = 'platform.admin_privileges',

	unified_auth = 'platform.unified_auth',
	domain_based_sso = 'platform.domain_based_sso',
	synced_content_window = 'platform.synced_content_window',

	// tests namespace does not make it into the database, these are local only
	test_oidc_auth = 'tests.test_oidc_auth',
	all_recording_download_requests_fail = 'tests.all_recording_download_requests_fail',
}

export type FeatureFlagMap = {
	[key in FeatureFlagsEnum]?: boolean;
};

export enum ChannelFeaturesEnum {
	first_flag = 'channel_feature.first_premium_feature',
	second_flag = 'channel_feature.second_premium_feature',
	cookie_opt_in = 'channel_feature.cookie_opt_in',
	enable_google_meet_breakouts = 'channel_feature.enable_google_meet_breakouts',
	enable_zoom_breakouts = 'channel_feature.enable_zoom_breakouts',
	sessions_v2 = 'channel_feature.sessions_v2',
	rsvp_integration = 'channel_feature.rsvp_sync_integration',
	dma_law = 'channel_feature.dma_law',
	event_publish_locking = 'channel_feature.event_publish_locking',
	google_meet_firesides = 'channel_feature.google_meet_firesides',
}

export type ChannelFeatures = {
	[key in ChannelFeaturesEnum]?: boolean;
};
